import { TRAFFIC_SUB_VIEW_MODEL } from '../Model/Model';
import Fines from './SubComponents/Fines';
import Geofences from './SubComponents/Geofences';
import ManageMainApp from './../TrafficFines/Functionality/ManageMainApp';
import {permissionObj} from '../../../../Helpers/permission';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 * @Description
 * This component controls which subview is displayed under the "Manage" section
 * of the Traffic Fines module. It dynamically renders either the **Fines** or **Geofences**
 * subcomponents based on the current value of `subView`.
 *
 * The component also connects to `ManageMainApp`, which provides logic
 * for handling subview transitions.
 *
 * @param {Object} props - Props passed to the Manage component.
 * @param {String} props.subView - Current active subview (FINES or GEOFENCES).
 * @param {String} props.searchElement - Value used to filter or search within the current subview.
 * @param {Function} props.setSearchElement - Setter function to update the searchElement value.
 * @param {Boolean} props.modified - Indicates if the content in the subview has been modified.
 * @param {React.RefObject} props.finesSubviewRef - Reference object to interact with the FinesSubview component.
 *
 * @returns {JSX.Element} Rendered Manage component that switches between Fines and Geofences views.
 */

const Manage = (props) => {
    const { subView, searchElement, setSearchElement, modified, finesSubviewRef } = props;
    const { DEV, permission, handleSubViewChange } = ManageMainApp(props);
    return (
        <>
            {(subView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES && ( DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_GEOFENCES_READ) ) )&& (
                <Geofences subView={subView} handleSubViewChange={handleSubViewChange}   searchElement={searchElement}
                    setSearchElement={setSearchElement} />
            )}

            {(subView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.FINES && (DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_FINES_READ)) ) && (
                <Fines
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    modified={modified}
                    finesSubviewRef={finesSubviewRef}
                />
            )}
        </>
    );
};

export default Manage;
